import { render } from "./VideoOnline.vue?vue&type=template&id=07b69e3a&scoped=true"
import script from "./VideoOnline.vue?vue&type=script&lang=js"
export * from "./VideoOnline.vue?vue&type=script&lang=js"

import "./VideoOnline.vue?vue&type=style&index=0&id=07b69e3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b69e3a"]])

export default __exports__